import hazeMorning from '../assets/hazeMorning.jpg'
import rainMorning from '../assets/rainMorning.jpg'
import rainNight from '../assets/rainNight.jpg'
import clearMorning from '../assets/clearMorning.jpg'
import clearNight from '../assets/clearNight.jpg'
import cloudMorning from '../assets/cloudMorning.jpg'
import cloudNight from '../assets/cloudNight.jpg';
import thunder from '..//assets/thunder.jpg'


export default {
    hazeMorning,
    rainMorning,
    rainNight,
    cloudNight,
    cloudMorning,
    clearMorning,
    clearNight,
    thunder,
};